import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useRouter } from '@bibliocommons/utils-routing';
import Heading from '@bibliocommons/heading';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { composeEvent, composeAnalytics } from 'app/helpers/analytics/compose';
import ClearFacets from 'app/components/shared/Facets/ClearFacets';

import './EmptyEventsSearch.scss';

const { EVENTS, CATEGORIES, ACTIONS } = AnalyticsConstants;

export default function EmptyEventsSearch() {
  const { query } = useRouter();

  sendAnalyticsEvents(
    composeAnalytics([
      composeEvent(EVENTS.EMPTY_EVENTS_SEARCH_PAGE, {
        gtmCategory: CATEGORIES.SEARCH_EMPTY,
        gtmAction: ACTIONS.RESULT,
        gtmLabel: query.q,
        gtmValue: 1
      })
    ])
  );

  return (
    <div className="cp-empty-events-search">
      <Heading tagName="h2" size="medium">
        <FormattedMessage id="empty_events_search_heading" />
      </Heading>
      <FormattedMessage id="empty_events_search_description" tagName="p" />
      <ClearFacets>
        <FormattedMessage id="explore_all_events" />
      </ClearFacets>
    </div>
  );
}
